/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_BadgeInputs */

const en_landing_faq_badge = /** @type {(inputs: Landing_Faq_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequently Asked Questions`)
};

const de_landing_faq_badge = /** @type {(inputs: Landing_Faq_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haeufig gestellte Fragen`)
};

const fr_landing_faq_badge = /** @type {(inputs: Landing_Faq_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions frequentes`)
};

const es_landing_faq_badge = /** @type {(inputs: Landing_Faq_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntas frecuentes`)
};

const it_landing_faq_badge = /** @type {(inputs: Landing_Faq_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domande frequenti`)
};

const nl_landing_faq_badge = /** @type {(inputs: Landing_Faq_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veelgestelde vragen`)
};

const pl_landing_faq_badge = /** @type {(inputs: Landing_Faq_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czesto zadawane pytania`)
};

const fi_landing_faq_badge = /** @type {(inputs: Landing_Faq_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usein kysytyt kysymykset`)
};

const da_landing_faq_badge = /** @type {(inputs: Landing_Faq_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofte stillede sporgsmal`)
};

const sv_landing_faq_badge = /** @type {(inputs: Landing_Faq_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vanliga fraagor`)
};

/**
* | output |
* | --- |
* | "Frequently Asked Questions" |
*
* @param {Landing_Faq_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_faq_badge = /** @type {((inputs?: Landing_Faq_BadgeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_BadgeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_faq_badge(inputs)
	if (locale === "fr") return fr_landing_faq_badge(inputs)
	if (locale === "es") return es_landing_faq_badge(inputs)
	if (locale === "it") return it_landing_faq_badge(inputs)
	if (locale === "nl") return nl_landing_faq_badge(inputs)
	if (locale === "pl") return pl_landing_faq_badge(inputs)
	if (locale === "fi") return fi_landing_faq_badge(inputs)
	if (locale === "da") return da_landing_faq_badge(inputs)
	if (locale === "sv") return sv_landing_faq_badge(inputs)
	return en_landing_faq_badge(inputs)
});